module.exports = __webpack_public_path__ + "static/img/6linda.8019caa5.jpg";